import { render } from "./SvgOk.vue?vue&type=template&id=5dfea64c&scoped=true"
const script = {}

import "./SvgOk.vue?vue&type=style&index=0&id=5dfea64c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dfea64c"]])

export default __exports__